import { render, staticRenderFns } from "./MtSupplysForm.vue?vue&type=template&id=467f037a&"
import script from "./MtSupplysForm.vue?vue&type=script&lang=js&"
export * from "./MtSupplysForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports